export default [
    {
        path: '/portfolio-photos',
        name: 'portfolio-photo',
        meta: { requiresAuth: true },
        component: () => import('@/pages/portfolio-photo/index.vue')
    }
]
